import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, baseURL } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { Modal, Container, Row, Col, Form, Nav } from "react-bootstrap";

export const TransactionLog = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [templateData, setTemplateData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [is_loading, setIs_Loading] = useState(false);
  const [listError, setlistError] = useState(false);
  suhbeader.setTitle("Transaction");
  const { authToken, accessTokenPrivilege } = useSelector(
    (state) => state.auth
  );
  const [status, setStatus] = useState(false);
  const [listMasterModel, setListMasterModel] = useState([]);
  const history = useHistory();
  useEffect(() => {
   // localStorage.removeItem("edit");
    getListMasterModel(page, limit);
  }, []);

  const getListMasterModel = async (pageData, limitData, search=null) => {
    setIs_Loading(true);
    const apiUrls = `${baseURLV1}/bo/participant/histroty?page=${pageData}&limit=${limitData}&type=${status ? 'earn':'burn'}${search ? `&search=${search}`:''}`; // รอแก้
    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        res.data.data.map((item) => {
          item.popupstart = ISOString(moment(item.popupstart).add(7, "hours"));
          item.popupend = ISOString(moment(item.popupend).add(7, "hours"));
          if (item.popupstart > item.popupend) {
            item.popupstart = "please change start time";
            item.popupend = "please change end time";
          }
          console.log(
            item.popupstart,
            item.popupend,
            item.popupend > item.popupstart
          );
        });
        setListMasterModel(res.data.data);
        setIs_Loading(false);
        setlistError(false);

        var totalpage = Math.ceil(res.data.total / res.data.limit);
        setTotalPage(totalpage);
        setTotalSize(res.data.total);
        setLimit(res.data.limit);
        setTemplateData(allData);
      })
      .catch((err) => {
        if (err.response) {
          setIs_Loading(false);
          setlistError(true);
        }
      });
  };

  const ISOString = (data) => {
    if (!data) {
      return "-";
    }
    let temp = new Date(data);
    console.log(temp.toISOString());
    console.log(
      `${temp
        .toISOString()
        .toString()
        .substring(0, 10)} ${temp
        .toISOString()
        .toString()
        .substring(11, 16)}`
    );
    return `${temp
      .toISOString()
      .toString()
      .substring(0, 10)} ${temp
      .toISOString()
      .toString()
      .substring(11, 16)}`;
    // console.log(Date(data).toISOString())
  };
  const columns = [
    /*{
      dataField: "id",
      text: "News Id",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },*/
    /*{
      text: "รูปภาพผู้ใช้",
      dataField: "image",
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            <img
              style={{
                width: "150px",
                //height: "120px",
              }}
              src={row.image}
            />
          </div>
        );
      },
    },*/
    {
      dataField: "title_th",
      text: "ชื่อ",
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: "130px" }}>
            <p>
              {row.participant?.firstname} {row.participant?.lastname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "title_en",
      text: "คะแนน",
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: "130px" }}>
            <p>{row.point}</p>
          </div>
        );
      },
    },

    /*{
      text: "Image Management",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => ImageManagement({ row, rowIndex })}
            >
              Image
            </button>

          </div>
        );
      },
    },*/
  ];

  const editItem = (data) => {
    history.push("/EditPointUser", data);
  };

  const deleteItem = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this limit point !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        //const token = localStorage.getItem('Token')
        axios
          .delete(`${baseURLV1}/banner/${data.row.id}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          })
          .then((res) => {
            Swal.fire("Deleted!", "Your model has been deleted.", "success");
            getListMasterModel(page, limit);
          })
          .catch((err) => {
            Swal.fire(
              "Deleted!",
              "Your model has been fail to deleted.",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your model is safe :)", "error");
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getListMasterModel(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    localStorage.setItem(
      "checkPage",
      JSON.stringify({ BannerManagement: value })
    );
    setPage(value);
    getListMasterModel(value, limit);
  };

  const handlePageSizeChange = (event) => {
    localStorage.setItem(
      "limitPage",
      JSON.stringify({ BannerManagement: event.target.value })
    );
    localStorage.setItem("checkPage", JSON.stringify({ BannerManagement: 1 }));
    setPage(1);
    setLimit(event.target.value);
    getListMasterModel(1, event.target.value);
  };

  return (
    <Card>
      <CardHeader title="Transaction">
        {/*<CardHeaderToolbar>
          <Link to="/CreateBanner">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>
        </CardHeaderToolbar>*/}
      </CardHeader>
      <CardBody>
        {/* /Search Btn/ */}

         <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> 

        <Nav variant="tabs" defaultActiveKey="link-0">
          <Nav.Item
            onClick={() => {
              setStatus(true);
              getListMasterModel(page, limit);
            }}
          >
            <Nav.Link eventKey="link-0">History burn</Nav.Link>
          </Nav.Item>
          <Nav.Item
            onClick={() => {
              setStatus(false);
              getListMasterModel(page, limit);
            }}
          >
            <Nav.Link eventKey="link-1">History earn</Nav.Link>
          </Nav.Item>
        </Nav>

        <BootstrapTable
          keyField="id"
          data={listMasterModel}
          columns={columns}
          wrapperClasses="table-responsive"
          bordered={false}
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="mt-3">
                {"Items per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <span class="mt-3 ml-5">Result : {totalSize} records</span>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
